/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_005: Question = {
  id: 'pres-005-superficie-espaces-conservation',
  oldId: '19',
  title: 'Superficie des espaces d\'intérêt pour la conservation identifiés en vertu d\'autres mécanismes et outils',
  number: '2.5',
  description: [''],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.HECTARE,
    },
  ],
};

const question_pres_005__v3: Question = {
  ...question_pres_005,
  frequency: 2,
};

export const question_pres_005_v2: Question = question_pres_005;
export const question_pres_005_v3: Question = question_pres_005__v3;
